module.exports = "/images/Cluster.svg?236880ad005b2d61c280f80c110f44e5";